import {OCSelectOptionType, OcGenericDialogFieldType, ValidationState} from '@oc/components'
import {User} from '@oc/user-management'
import {OcAppBarState} from '../../../Model/OcAppBarState'
import {EditProfileDialogDatagroups} from './editProfileDialogInterfaces'
import {messages} from '../../translations'
import {validatePhoneNumber} from '@oc/utils'

const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/

export function getEditProfileDialogDataGroups(state: OcAppBarState): EditProfileDialogDatagroups {
    const userGroupsSuggestions: OCSelectOptionType<string>[] =
        state.loggedUser?.groups?.map(group => {
            return {label: group, value: group}
        }) || []

    const canEdit = !!state.loggedUser
    const datagroups: EditProfileDialogDatagroups = {
        userInformation: {
            index: 0,
            label: messages.getText('appBar', 'userInformation'),
            fields: {
                username: {
                    index: 0,
                    width: 2,
                    type: OcGenericDialogFieldType.String,
                    label: messages.getText('appBar', 'username'),
                    disabled: true
                },
                givenName: {
                    index: 0,
                    width: 2,
                    type: OcGenericDialogFieldType.String,
                    label: messages.getText('appBar', 'firstName'),
                    disabled: !canEdit,
                    mandatory: true
                },
                familyName: {
                    index: 0,
                    width: 2,
                    type: OcGenericDialogFieldType.String,
                    label: messages.getText('appBar', 'lastName'),
                    disabled: !canEdit,
                    mandatory: true
                },
                email: {
                    index: 0,
                    width: 2,
                    type: OcGenericDialogFieldType.String,
                    label: messages.getText('appBar', 'email'),
                    validateValue: (value?: string) => {
                        if (value) {
                            const isValid = (value.match(emailRegex) || []).length > 0

                            return {
                                error: isValid ? ValidationState.OK : ValidationState.Error,
                                sanitizedValue: value,
                                message: isValid ? '' : messages.getText('appBar', 'notValidEmail')
                            }
                        }
                        return {
                            error: ValidationState.OK,
                            sanitizedValue: value,
                            message: ''
                        }
                    },
                    disabled: true,
                    mandatory: true
                },
                phoneNumber: {
                    index: 0,
                    width: 2,
                    type: OcGenericDialogFieldType.String,
                    label: messages.getText('appBar', 'phone'),
                    getValue: (user: User) => (user.phoneNumber !== null ? user.phoneNumber : ''),
                    validateValue: (value?: string) => {
                        if (value) {
                            const isValid = validatePhoneNumber(value)

                            return {
                                error: isValid ? ValidationState.OK : ValidationState.Error,
                                sanitizedValue: value,
                                message: isValid ? '' : messages.getText('appBar', 'notValidPhone')
                            }
                        }
                        return {
                            error: ValidationState.OK,
                            sanitizedValue: value,
                            message: ''
                        }
                    },
                    disabled: !canEdit
                }
            }
        },
        userGroups: {
            index: 1,
            label: messages.getText('appBar', 'userGroups'),
            fields: {
                groups: {
                    index: 0,
                    width: 4,
                    type: OcGenericDialogFieldType.Enum,
                    label: messages.getText('appBar', 'userGroups'),
                    suggestions: userGroupsSuggestions,
                    multiSelect: true,
                    disabled: true,
                    getValue: (user: User) => userGroupsSuggestions.filter(group => user.groups?.includes(group.value))
                }
            }
        }
    }
    return datagroups
}
